<div class="dialog-heading">
  <div class="btn-close">
    <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>
  <div style="text-align: center;">
    <h3 [innerHtml]="Message"></h3>
  </div>
